import { render } from "./NumberField.vue?vue&type=template&id=0ab6104d"
import script from "./NumberField.vue?vue&type=script&lang=js"
export * from "./NumberField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"NumberField.vue"]])

export default __exports__